module.exports = __webpack_public_path__ + "static/media/verifyid.4a556e36.png";